import React from 'react';
import { ErrorCode } from 'react-dropzone';
import { useSelector } from 'react-redux';
import { Button, ButtonGroup, Content, Dialog, DialogContainer, Divider, Heading, useDialogContainer, View, } from '@adobe/react-spectrum';
import { Flex } from '@react-spectrum/layout';
import { EditorActions } from 'app/stores/editor/actions';
import { useAppDispatch } from 'app/stores/store';
import { Text } from 'app/views/components/typography/Text';
const Error = (props) => {
    const { error } = props;
    switch (error.code) {
        case ErrorCode.TooManyFiles:
            return React.createElement(Text, null, "Too many files loaded");
            break;
        case ErrorCode.FileInvalidType:
            return React.createElement(Text, null, "Unsupported or invalid image type");
        case ErrorCode.FileTooLarge: {
            const fileMaxSize = configGet('fileUploadMaxSize', 1e6);
            const fileMaxSizeMB = Math.round(fileMaxSize / 1e6).toFixed(0);
            return (React.createElement(Flex, { direction: "column" },
                React.createElement(Text, null, "File size exceeds maximum allowed"),
                React.createElement(Text, { size: "S" }, `Maximum supported size: ${fileMaxSizeMB}MB`)));
        }
        case ErrorCode.FileTooSmall:
            return React.createElement(Text, null, "File size is to small.");
        default:
            break;
    }
    return React.createElement(Text, null, "Unexpected error");
};
const FileRejection = (props) => {
    const { rejection } = props;
    return (React.createElement(View, null,
        React.createElement(Flex, { direction: "column" },
            React.createElement(Text, null, rejection.name),
            React.createElement(View, { marginStart: "size-200" }, rejection.errors.map(error => (React.createElement(Error, { key: error.code, error: error })))))));
};
const RejectionsInfoDialog = (props) => {
    const { rejections } = props;
    const dialog = useDialogContainer();
    return (React.createElement(Dialog, null,
        React.createElement(Heading, null, "Some files were not loaded"),
        React.createElement(Divider, { size: "S" }),
        React.createElement(Content, null,
            React.createElement(View, { maxHeight: "size-2400", overflow: "hidden scroll" },
                React.createElement(Flex, { direction: "column", gap: "size-100" }, rejections.map(rejection => (React.createElement(FileRejection, { key: rejection.name, rejection: rejection })))))),
        React.createElement(ButtonGroup, null,
            React.createElement(Button, { variant: "secondary", onPress: dialog.dismiss }, "Dismiss"))));
};
export const RejectionsDialog = () => {
    const dispatch = useAppDispatch();
    const rejections = useSelector((state) => state.editor.rejections);
    const onDismiss = React.useCallback(() => {
        dispatch(EditorActions.setRejections({ rejections: undefined }));
    }, [dispatch]);
    if (!rejections || !rejections.length) {
        return null;
    }
    return (React.createElement(DialogContainer, { onDismiss: onDismiss },
        React.createElement(RejectionsInfoDialog, { rejections: rejections })));
};
